const API_BASE = '/.proxy/acf';

interface AuthorizeResponse {
    token: string;
    access_token: string;
}

interface QuestStatusResponse {
    user_id: string;
    quest_id: string;
    enrolled_at: string;
    completed_at: string | null;
    claimed_at: string | null;
}

let auth_token = '';

export function setAuthToken(token: string) {
    auth_token = token;
}

// The initial call to exchange the auth code for an access token
export async function authorize(code: string): Promise<AuthorizeResponse> {
    const data = await call<AuthorizeResponse>('POST', '/authorize', { code });
    return data;
}

export async function register() {
    return await call<{ authToken: string }>('POST', '/arise/register');
}

export async function checkQuest(): Promise<QuestStatusResponse> {
    if (!auth_token) throw new Error('No auth token set');
    const data = await call<QuestStatusResponse>('GET', '/quest/status');
    return data;
}

// Removed for now, using questProgress with max progress instead
// export async function completeQuest(): Promise<void> {
//     await call('POST', '/quest/complete');
// }

export async function questProgress(progress: number): Promise<boolean> {
    type QuestProgressResponse = { status: 'ok' } | { status: 'error'; message: string };
    const response = await call<QuestProgressResponse>('POST', '/quest/progress', {
        progress,
    });
    return response?.status === 'ok';
}

export async function botRegister(locale: string): Promise<void> {
    await call('POST', '/bot/register', { locale });
}

async function call<T>(method: string, endpoint: string, body?: any, timeout = 10000): Promise<T> {
    const abort = new AbortController();
    setTimeout(() => abort.abort(), timeout);
    const res = await fetch(API_BASE + endpoint, {
        method,
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': auth_token,
            'X-Universe-ID': process.env.PUBLIC_INSTANCE_ID,
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: abort.signal,
    });
    return res.json();
}
